import React from 'react';
import { Typography, Box, Button, IconButton, Fade, Paper, useMediaQuery, useTheme } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SecurityIcon from '@mui/icons-material/Security';
import { useNavigate } from 'react-router-dom';
import './App.css';
import PolicyPage from './components/PolicyPage';
import { RouteSeo } from './components/RouteSeo';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
    <RouteSeo
      title="Privacy Policy | Aylet Aib"
      canonicalPath="/privacy"
      description="Learn how Aylet Aib collects, uses, and protects your personal information."
    />
    <PolicyPage 
      title="Privacy Policy"
      icon={<SecurityIcon />}
    >
      <Typography component="h2" variant="h5" gutterBottom sx={{ 
        fontWeight: 600,
        fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.5rem' }
      }}>
        Introduction
      </Typography>
      <Typography paragraph sx={{ mb: 3 }}>
        This Privacy Policy describes how Aylet Aib ("we", "us", or "our") collects, uses, and shares your information when you use our website, services, and applications ("Services").
      </Typography>

      <Typography component="h2" variant="h5" gutterBottom sx={{ 
        fontWeight: 600,
        fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.5rem' },
        mt: 4 
      }}>
        Information We Collect
      </Typography>
      <Typography paragraph>
        We may collect the following types of information:
      </Typography>
      <ul>
        <li>
          <Typography paragraph>
            <strong>Personal Information:</strong> Such as your name and email address when you subscribe to our newsletter.
          </Typography>
        </li>
        <li>
          <Typography paragraph>
            <strong>Device Information:</strong> We collect information about the device you use to access our Services, including IP address, browser type, and operating system.
          </Typography>
        </li>
        <li>
          <Typography paragraph>
            <strong>Usage Data:</strong> We collect information about how you interact with our Services, including pages visited and time spent.
          </Typography>
        </li>
      </ul>

      <Typography component="h2" variant="h5" gutterBottom sx={{ 
        fontWeight: 600,
        fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.5rem' },
        mt: 4 
      }}>
        How We Use Your Information
      </Typography>
      <Typography paragraph>
        We use the information we collect to:
      </Typography>
      <ul>
        <li>
          <Typography paragraph>
            Provide, maintain, and improve our Services
          </Typography>
        </li>
        <li>
          <Typography paragraph>
            Communicate with you, including sending updates and marketing messages
          </Typography>
        </li>
        <li>
          <Typography paragraph>
            Understand how users interact with our Services
          </Typography>
        </li>
        <li>
          <Typography paragraph>
            Detect, prevent, and address technical issues
          </Typography>
        </li>
      </ul>

      <Typography component="h2" variant="h5" gutterBottom sx={{ 
        fontWeight: 600,
        fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.5rem' },
        mt: 4
      }}>
        Your Rights
      </Typography>
      <Typography paragraph>
        Welcome to Aylet Aib. We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you about how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.
      </Typography>
      <Typography paragraph>
        If you choose to communicate with us via WhatsApp, your usage is also subject to the WhatsApp Terms of Service and Privacy Policy. We are committed to complying with the WhatsApp Business Policy in all our communications.
      </Typography>

      <Typography component="h2" variant="h5" gutterBottom sx={{ 
        fontWeight: 600,
        fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.5rem' },
        mt: 4
      }}>
        Contact Us
      </Typography>
      <Typography paragraph>
        If you have any questions about this privacy policy or our privacy practices, please contact us at: info@ayletaib.com
      </Typography>
    </PolicyPage>
    </>
  );
};

export default PrivacyPolicy; 